var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesktopHexagons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 784,
    viewBox: "0 0 1440 784",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2729_1416)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1077.25 107.025C1075.18 103.359 1075.18 98.8732 1077.25 95.2071L1106.44 43.6443C1108.57 39.8826 1112.55 37.5571 1116.88 37.5571L1174.84 37.5571C1179.16 37.5571 1183.15 39.8826 1185.28 43.6443L1214.46 95.2071C1216.54 98.8732 1216.54 103.359 1214.46 107.025L1185.28 158.588C1183.15 162.35 1179.16 164.675 1174.84 164.675H1116.88C1112.55 164.675 1108.57 162.35 1106.44 158.588L1077.25 107.025Z",
    fill: "url(#paint0_linear_2729_1416)",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1077.69 95.4534L1106.87 43.8906C1108.91 40.2856 1112.73 38.0571 1116.88 38.0571L1174.84 38.0571C1178.98 38.0571 1182.8 40.2856 1184.84 43.8906L1214.03 95.4534C1216.02 98.9667 1216.02 103.266 1214.03 106.779L1184.84 158.342C1182.8 161.947 1178.98 164.175 1174.84 164.175H1116.88C1112.73 164.175 1108.91 161.947 1106.87 158.342L1077.69 106.779C1075.7 103.266 1075.7 98.9667 1077.69 95.4534Z",
    stroke: "#FFEEED",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M962.135 173.745C960.06 170.079 960.06 165.593 962.135 161.927L991.32 110.364C993.449 106.602 997.437 104.277 1001.76 104.277H1059.72C1064.04 104.277 1068.03 106.602 1070.16 110.364L1099.34 161.927C1101.42 165.593 1101.42 170.079 1099.34 173.745L1070.16 225.308C1068.03 229.069 1064.04 231.395 1059.72 231.395H1001.76C997.437 231.395 993.449 229.069 991.32 225.308L962.135 173.745Z",
    fill: "url(#paint1_linear_2729_1416)",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M962.57 162.173L991.755 110.61C993.795 107.005 997.617 104.777 1001.76 104.777H1059.72C1063.86 104.777 1067.68 107.005 1069.72 110.61L1098.91 162.173C1100.9 165.686 1100.9 169.985 1098.91 173.499L1069.72 225.061C1067.68 228.666 1063.86 230.895 1059.72 230.895H1001.76C997.617 230.895 993.795 228.666 991.755 225.061L962.57 173.499C960.582 169.985 960.582 165.686 962.57 162.173Z",
    stroke: "#FFEEED",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1077.25 241.354C1075.18 237.688 1075.18 233.202 1077.25 229.536L1106.44 177.973C1108.57 174.212 1112.55 171.886 1116.88 171.886L1174.84 171.886C1179.16 171.886 1183.15 174.212 1185.28 177.973L1214.46 229.536C1216.54 233.202 1216.54 237.688 1214.46 241.354L1185.28 292.917C1183.15 296.679 1179.16 299.004 1174.84 299.004H1116.88C1112.55 299.004 1108.57 296.679 1106.44 292.917L1077.25 241.354Z",
    fill: "url(#paint2_linear_2729_1416)",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1077.69 229.783L1106.87 178.22C1108.91 174.615 1112.73 172.386 1116.88 172.386L1174.84 172.386C1178.98 172.386 1182.8 174.615 1184.84 178.22L1214.03 229.783C1216.02 233.296 1216.02 237.595 1214.03 241.108L1184.84 292.671C1182.8 296.276 1178.98 298.504 1174.84 298.504H1116.88C1112.73 298.504 1108.91 296.276 1106.87 292.671L1077.69 241.108C1075.7 237.595 1075.7 233.296 1077.69 229.783Z",
    stroke: "#FFEEED",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1191.76 173.745C1189.68 170.079 1189.68 165.593 1191.76 161.927L1220.94 110.364C1223.07 106.602 1227.06 104.277 1231.38 104.277L1289.34 104.277C1293.66 104.277 1297.65 106.602 1299.78 110.364L1328.96 161.927C1331.04 165.593 1331.04 170.079 1328.96 173.745L1299.78 225.308C1297.65 229.069 1293.66 231.395 1289.34 231.395H1231.38C1227.06 231.395 1223.07 229.069 1220.94 225.308L1191.76 173.745Z",
    fill: "url(#paint3_linear_2729_1416)",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1192.19 162.173L1221.38 110.61C1223.42 107.005 1227.24 104.777 1231.38 104.777L1289.34 104.777C1293.48 104.777 1297.3 107.005 1299.34 110.61L1328.53 162.173C1330.52 165.686 1330.52 169.985 1328.53 173.499L1299.34 225.061C1297.3 228.666 1293.48 230.895 1289.34 230.895H1231.38C1227.24 230.895 1223.42 228.666 1221.38 225.061L1192.19 173.499C1190.2 169.985 1190.2 165.686 1192.19 162.173Z",
    stroke: "#FFEEED",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1307.36 241.354C1305.29 237.688 1305.29 233.202 1307.36 229.536L1336.54 177.973C1338.67 174.212 1342.66 171.886 1346.98 171.886L1404.94 171.886C1409.27 171.886 1413.26 174.212 1415.38 177.973L1444.57 229.536C1446.64 233.202 1446.64 237.688 1444.57 241.354L1415.38 292.917C1413.26 296.679 1409.27 299.004 1404.94 299.004H1346.98C1342.66 299.004 1338.67 296.679 1336.54 292.917L1307.36 241.354Z",
    fill: "url(#paint4_linear_2729_1416)",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1307.8 229.783L1336.98 178.22C1339.02 174.615 1342.84 172.386 1346.98 172.386L1404.94 172.386C1409.09 172.386 1412.91 174.615 1414.95 178.22L1444.13 229.783C1446.12 233.296 1446.12 237.595 1444.13 241.108L1414.95 292.671C1412.91 296.276 1409.09 298.504 1404.94 298.504H1346.98C1342.84 298.504 1339.02 296.276 1336.98 292.671L1307.8 241.108C1305.81 237.595 1305.81 233.296 1307.8 229.783Z",
    stroke: "#FFEEED",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1076.32 377.528C1074.24 373.862 1074.24 369.376 1076.32 365.71L1105.5 314.147C1107.63 310.385 1111.62 308.06 1115.94 308.06H1173.9C1178.22 308.06 1182.21 310.385 1184.34 314.147L1213.52 365.71C1215.6 369.376 1215.6 373.862 1213.52 377.528L1184.34 429.091C1182.21 432.853 1178.22 435.178 1173.9 435.178H1115.94C1111.62 435.178 1107.63 432.853 1105.5 429.091L1076.32 377.528Z",
    fill: "url(#paint5_linear_2729_1416)",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1076.75 365.956L1105.93 314.394C1107.98 310.789 1111.8 308.56 1115.94 308.56H1173.9C1178.04 308.56 1181.86 310.789 1183.9 314.394L1213.09 365.956C1215.08 369.47 1215.08 373.769 1213.09 377.282L1183.9 428.845C1181.86 432.45 1178.04 434.678 1173.9 434.678H1115.94C1111.8 434.678 1107.98 432.45 1105.93 428.845L1076.75 377.282C1074.76 373.769 1074.76 369.47 1076.75 365.956Z",
    stroke: "#FFEEED",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M961.198 444.247C959.123 440.581 959.123 436.095 961.198 432.429L990.382 380.866C992.511 377.105 996.5 374.779 1000.82 374.779H1058.78C1063.1 374.779 1067.09 377.105 1069.22 380.866L1098.41 432.429C1100.48 436.095 1100.48 440.581 1098.41 444.247L1069.22 495.81C1067.09 499.572 1063.1 501.897 1058.78 501.897H1000.82C996.5 501.897 992.511 499.572 990.382 495.81L961.198 444.247Z",
    fill: "url(#paint6_linear_2729_1416)",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M961.633 432.676L990.817 381.113C992.858 377.508 996.68 375.279 1000.82 375.279H1058.78C1062.92 375.279 1066.75 377.508 1068.79 381.113L1097.97 432.676C1099.96 436.189 1099.96 440.488 1097.97 444.001L1068.79 495.564C1066.75 499.169 1062.92 501.397 1058.78 501.397H1000.82C996.68 501.397 992.858 499.169 990.817 495.564L961.633 444.001C959.644 440.488 959.644 436.189 961.633 432.676Z",
    stroke: "#FFEEED",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1076.32 511.857C1074.24 508.191 1074.24 503.705 1076.32 500.039L1105.5 448.476C1107.63 444.714 1111.62 442.389 1115.94 442.389H1173.9C1178.22 442.389 1182.21 444.714 1184.34 448.476L1213.52 500.039C1215.6 503.705 1215.6 508.191 1213.52 511.857L1184.34 563.42C1182.21 567.181 1178.22 569.507 1173.9 569.507H1115.94C1111.62 569.507 1107.63 567.181 1105.5 563.42L1076.32 511.857Z",
    fill: "url(#paint7_linear_2729_1416)",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1076.75 500.285L1105.93 448.722C1107.98 445.117 1111.8 442.889 1115.94 442.889H1173.9C1178.04 442.889 1181.86 445.117 1183.9 448.722L1213.09 500.285C1215.08 503.798 1215.08 508.097 1213.09 511.61L1183.9 563.173C1181.86 566.778 1178.04 569.007 1173.9 569.007H1115.94C1111.8 569.007 1107.98 566.778 1105.93 563.173L1076.75 511.61C1074.76 508.097 1074.76 503.798 1076.75 500.285Z",
    stroke: "#FFEEED",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1329.4 308.964C1331.47 305.298 1331.47 300.812 1329.4 297.146L1300.21 245.583C1298.09 241.821 1294.1 239.496 1289.77 239.496L1231.81 239.496C1227.49 239.496 1223.5 241.821 1221.37 245.583L1192.19 297.146C1190.12 300.812 1190.12 305.298 1192.19 308.964L1221.37 360.526C1223.5 364.288 1227.49 366.614 1231.81 366.614H1289.77C1294.1 366.614 1298.09 364.288 1300.21 360.526L1329.4 308.964Z",
    fill: "url(#paint8_linear_2729_1416)",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1328.96 297.392L1299.78 245.829C1297.74 242.224 1293.92 239.996 1289.77 239.996L1231.81 239.996C1227.67 239.996 1223.85 242.224 1221.81 245.829L1192.63 297.392C1190.64 300.905 1190.64 305.204 1192.63 308.717L1221.81 360.28C1223.85 363.885 1227.67 366.114 1231.81 366.114H1289.77C1293.92 366.114 1297.74 363.885 1299.78 360.28L1328.96 308.717C1330.95 305.204 1330.95 300.905 1328.96 297.392Z",
    stroke: "#FFEEED",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1329.4 444.249C1331.47 440.583 1331.47 436.097 1329.4 432.431L1300.21 380.868C1298.09 377.107 1294.1 374.781 1289.77 374.781H1231.81C1227.49 374.781 1223.5 377.107 1221.37 380.868L1192.19 432.431C1190.12 436.097 1190.12 440.583 1192.19 444.249L1221.37 495.812C1223.5 499.574 1227.49 501.899 1231.81 501.899H1289.77C1294.1 501.899 1298.09 499.574 1300.21 495.812L1329.4 444.249Z",
    fill: "url(#paint9_linear_2729_1416)",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1328.96 432.678L1299.78 381.115C1297.74 377.51 1293.92 375.281 1289.77 375.281H1231.81C1227.67 375.281 1223.85 377.51 1221.81 381.115L1192.63 432.678C1190.64 436.191 1190.64 440.49 1192.63 444.003L1221.81 495.566C1223.85 499.171 1227.67 501.399 1231.81 501.399H1289.77C1293.92 501.399 1297.74 499.171 1299.78 495.566L1328.96 444.003C1330.95 440.49 1330.95 436.191 1328.96 432.678Z",
    stroke: "#FFEEED",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1307.81 512.377C1305.74 508.711 1305.74 504.225 1307.81 500.559L1336.99 448.996C1339.12 445.234 1343.11 442.909 1347.43 442.909H1405.39C1409.72 442.909 1413.71 445.234 1415.83 448.996L1445.02 500.559C1447.09 504.225 1447.09 508.711 1445.02 512.377L1415.83 563.94C1413.71 567.701 1409.72 570.027 1405.39 570.027H1347.43C1343.11 570.027 1339.12 567.701 1336.99 563.94L1307.81 512.377Z",
    fill: "url(#paint10_linear_2729_1416)",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1308.25 500.805L1337.43 449.242C1339.47 445.637 1343.29 443.409 1347.43 443.409H1405.39C1409.54 443.409 1413.36 445.637 1415.4 449.242L1444.58 500.805C1446.57 504.318 1446.57 508.617 1444.58 512.13L1415.4 563.693C1413.36 567.298 1409.54 569.527 1405.39 569.527H1347.43C1343.29 569.527 1339.47 567.298 1337.43 563.693L1308.25 512.13C1306.26 508.617 1306.26 504.318 1308.25 500.805Z",
    stroke: "#FFEEED",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1192.69 579.096C1190.62 575.43 1190.62 570.945 1192.69 567.278L1221.88 515.716C1224.01 511.954 1227.99 509.628 1232.32 509.628H1290.28C1294.6 509.628 1298.59 511.954 1300.72 515.716L1329.9 567.278C1331.98 570.945 1331.98 575.43 1329.9 579.096L1300.72 630.659C1298.59 634.421 1294.6 636.746 1290.28 636.746H1232.32C1227.99 636.746 1224.01 634.421 1221.88 630.659L1192.69 579.096Z",
    fill: "url(#paint11_linear_2729_1416)",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.13 567.525L1222.31 515.962C1224.35 512.357 1228.17 510.128 1232.32 510.128H1290.28C1294.42 510.128 1298.24 512.357 1300.28 515.962L1329.47 567.525C1331.45 571.038 1331.45 575.337 1329.47 578.85L1300.28 630.413C1298.24 634.018 1294.42 636.246 1290.28 636.246H1232.32C1228.17 636.246 1224.35 634.018 1222.31 630.413L1193.13 578.85C1191.14 575.337 1191.14 571.038 1193.13 567.525Z",
    stroke: "#FFEEED",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.809 512.377C984.884 508.711 984.884 504.225 982.809 500.559L953.625 448.996C951.496 445.234 947.507 442.909 943.185 442.909H885.225C880.902 442.909 876.914 445.234 874.785 448.996L845.6 500.559C843.525 504.225 843.525 508.711 845.6 512.377L874.785 563.94C876.914 567.701 880.902 570.027 885.225 570.027H943.185C947.507 570.027 951.496 567.701 953.625 563.94L982.809 512.377Z",
    fill: "url(#paint12_linear_2729_1416)",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.374 500.805L953.19 449.242C951.149 445.637 947.327 443.409 943.185 443.409H885.225C881.083 443.409 877.261 445.637 875.22 449.242L846.036 500.805C844.047 504.318 844.047 508.617 846.036 512.13L875.22 563.693C877.261 567.298 881.083 569.527 885.225 569.527H943.185C947.327 569.527 951.149 567.298 953.19 563.693L982.374 512.13C984.363 508.617 984.363 504.318 982.374 500.805Z",
    stroke: "#FFEEED",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1097.93 579.096C1100 575.43 1100 570.945 1097.93 567.278L1068.74 515.716C1066.61 511.954 1062.62 509.628 1058.3 509.628H1000.34C996.02 509.628 992.032 511.954 989.903 515.716L960.718 567.278C958.643 570.945 958.643 575.43 960.718 579.096L989.903 630.659C992.032 634.421 996.02 636.746 1000.34 636.746H1058.3C1062.62 636.746 1066.61 634.421 1068.74 630.659L1097.93 579.096Z",
    fill: "url(#paint13_linear_2729_1416)",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1097.49 567.525L1068.31 515.962C1066.27 512.357 1062.44 510.128 1058.3 510.128H1000.34C996.2 510.128 992.378 512.357 990.338 515.962L961.153 567.525C959.165 571.038 959.165 575.337 961.153 578.85L990.338 630.413C992.378 634.018 996.2 636.246 1000.34 636.246H1058.3C1062.44 636.246 1066.27 634.018 1068.31 630.413L1097.49 578.85C1099.48 575.337 1099.48 571.038 1097.49 567.525Z",
    stroke: "#FFEEED",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.809 645.816C984.884 642.15 984.884 637.664 982.809 633.998L953.625 582.435C951.496 578.674 947.507 576.348 943.185 576.348H885.225C880.902 576.348 876.914 578.674 874.785 582.435L845.6 633.998C843.525 637.664 843.525 642.15 845.6 645.816L874.785 697.379C876.914 701.141 880.902 703.466 885.225 703.466H943.185C947.507 703.466 951.496 701.141 953.625 697.379L982.809 645.816Z",
    fill: "url(#paint14_linear_2729_1416)",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.374 634.244L953.19 582.682C951.149 579.077 947.327 576.848 943.185 576.848H885.225C881.083 576.848 877.261 579.077 875.22 582.682L846.036 634.244C844.047 637.758 844.047 642.057 846.036 645.57L875.22 697.133C877.261 700.738 881.083 702.966 885.225 702.966H943.185C947.327 702.966 951.149 700.738 953.19 697.133L982.374 645.57C984.363 642.057 984.363 637.758 982.374 634.244Z",
    stroke: "#FFEEED",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867.687 579.987C869.762 576.321 869.762 571.835 867.687 568.169L838.503 516.606C836.373 512.844 832.385 510.519 828.063 510.519H770.103C765.78 510.519 761.792 512.844 759.663 516.606L730.478 568.169C728.403 571.835 728.403 576.321 730.478 579.987L759.663 631.549C761.792 635.311 765.78 637.637 770.103 637.637H828.063C832.385 637.637 836.373 635.311 838.503 631.549L867.687 579.987Z",
    fill: "url(#paint15_linear_2729_1416)",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867.252 568.415L838.067 516.852C836.027 513.247 832.205 511.019 828.063 511.019H770.103C765.961 511.019 762.138 513.247 760.098 516.852L730.913 568.415C728.925 571.928 728.925 576.227 730.913 579.74L760.098 631.303C762.138 634.908 765.961 637.137 770.103 637.137H828.063C832.205 637.137 836.027 634.908 838.067 631.303L867.252 579.74C869.241 576.227 869.241 571.928 867.252 568.415Z",
    stroke: "#FFEEED",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.633 645.816C753.708 642.15 753.708 637.664 751.633 633.998L722.448 582.435C720.319 578.674 716.33 576.348 712.008 576.348H654.048C649.726 576.348 645.737 578.674 643.608 582.435L614.424 633.998C612.349 637.664 612.349 642.15 614.424 645.816L643.608 697.379C645.737 701.141 649.726 703.466 654.048 703.466H712.008C716.33 703.466 720.319 701.141 722.448 697.379L751.633 645.816Z",
    fill: "url(#paint16_linear_2729_1416)",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.197 634.244L722.013 582.682C719.972 579.077 716.15 576.848 712.008 576.848H654.048C649.906 576.848 646.084 579.077 644.043 582.682L614.859 634.244C612.87 637.758 612.87 642.057 614.859 645.57L644.043 697.133C646.084 700.738 649.906 702.966 654.048 702.966H712.008C716.15 702.966 719.972 700.738 722.013 697.133L751.197 645.57C753.186 642.057 753.186 637.758 751.197 634.244Z",
    stroke: "#FFEEED",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.127 107.025C985.202 103.359 985.202 98.8732 983.127 95.2071L953.943 43.6443C951.813 39.8826 947.825 37.5571 943.503 37.5571L885.543 37.5571C881.22 37.5571 877.232 39.8826 875.103 43.6443L845.918 95.2071C843.843 98.8732 843.843 103.359 845.918 107.025L875.103 158.588C877.232 162.35 881.22 164.675 885.543 164.675L943.503 164.675C947.825 164.675 951.813 162.35 953.943 158.588L983.127 107.025Z",
    fill: "url(#paint17_linear_2729_1416)",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.692 95.4534L953.507 43.8906C951.467 40.2856 947.645 38.0571 943.503 38.0571L885.543 38.0571C881.4 38.0571 877.578 40.2856 875.538 43.8906L846.353 95.4534C844.365 98.9667 844.365 103.266 846.353 106.779L875.538 158.342C877.578 161.947 881.4 164.175 885.543 164.175L943.503 164.175C947.645 164.175 951.467 161.947 953.507 158.342L982.692 106.779C984.681 103.266 984.681 98.9667 982.692 95.4534Z",
    stroke: "#FFEEED",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1097.47 715.054C1099.54 711.387 1099.54 706.902 1097.47 703.235L1068.28 651.673C1066.15 647.911 1062.17 645.585 1057.84 645.585H999.884C995.562 645.585 991.573 647.911 989.444 651.673L960.26 703.235C958.185 706.902 958.185 711.387 960.26 715.054L989.444 766.616C991.573 770.378 995.562 772.704 999.884 772.704H1057.84C1062.17 772.704 1066.15 770.378 1068.28 766.616L1097.47 715.054Z",
    fill: "url(#paint18_linear_2729_1416)",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1097.03 703.482L1067.85 651.919C1065.81 648.314 1061.99 646.085 1057.84 646.085H999.884C995.742 646.085 991.92 648.314 989.879 651.919L960.695 703.482C958.706 706.995 958.706 711.294 960.695 714.807L989.879 766.37C991.92 769.975 995.742 772.204 999.884 772.204H1057.84C1061.99 772.204 1065.81 769.975 1067.85 766.37L1097.03 714.807C1099.02 711.294 1099.02 706.995 1097.03 703.482Z",
    stroke: "#FFEEED",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.553 79.3006C142.628 75.6345 142.628 71.1486 140.553 67.4825L111.369 15.9197C109.24 12.1579 105.251 9.83252 100.929 9.83252L42.9691 9.83252C38.6466 9.83252 34.6583 12.158 32.5291 15.9197L3.34452 67.4825C1.2695 71.1486 1.2695 75.6345 3.34452 79.3006L32.5291 130.863C34.6583 134.625 38.6466 136.951 42.9691 136.951L100.929 136.951C105.251 136.951 109.24 134.625 111.369 130.863L140.553 79.3006Z",
    fill: "url(#paint19_linear_2729_1416)",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.118 67.7288L110.934 16.166C108.893 12.561 105.071 10.3325 100.929 10.3325L42.9691 10.3325C38.8267 10.3325 35.0047 12.561 32.9643 16.166L3.77965 67.7288C1.79112 71.2421 1.79112 75.541 3.77965 79.0543L32.9643 130.617C35.0047 134.222 38.8267 136.451 42.9691 136.451L100.929 136.451C105.071 136.451 108.893 134.222 110.934 130.617L140.118 79.0543C142.107 75.541 142.107 71.2421 140.118 67.7288Z",
    stroke: "#FFEEED",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.671 146.02C257.746 142.354 257.746 137.868 255.671 134.202L226.486 82.6394C224.357 78.8777 220.369 76.5522 216.047 76.5522L158.087 76.5522C153.764 76.5522 149.776 78.8777 147.647 82.6394L118.462 134.202C116.387 137.868 116.387 142.354 118.462 146.02L147.647 197.583C149.776 201.345 153.764 203.67 158.087 203.67L216.047 203.67C220.369 203.67 224.357 201.345 226.486 197.583L255.671 146.02Z",
    fill: "url(#paint20_linear_2729_1416)",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.236 134.449L226.051 82.8857C224.011 79.2807 220.189 77.0522 216.047 77.0522L158.087 77.0522C153.944 77.0522 150.122 79.2808 148.082 82.8857L118.897 134.449C116.909 137.962 116.909 142.261 118.897 145.774L148.082 197.337C150.122 200.942 153.944 203.17 158.087 203.17L216.047 203.17C220.189 203.17 224.011 200.942 226.051 197.337L255.236 145.774C257.225 142.261 257.225 137.962 255.236 134.449Z",
    stroke: "#FFEEED",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.553 212.74C142.628 209.074 142.628 204.588 140.553 200.922L111.369 149.359C109.24 145.597 105.251 143.272 100.929 143.272L42.9691 143.272C38.6466 143.272 34.6583 145.597 32.5291 149.359L3.34452 200.922C1.2695 204.588 1.2695 209.074 3.34452 212.74L32.5291 264.303C34.6583 268.065 38.6466 270.39 42.9691 270.39H100.929C105.251 270.39 109.24 268.065 111.369 264.303L140.553 212.74Z",
    fill: "url(#paint21_linear_2729_1416)",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.118 201.168L110.934 149.605C108.893 146 105.071 143.772 100.929 143.772L42.9691 143.772C38.8267 143.772 35.0047 146 32.9643 149.605L3.77965 201.168C1.79112 204.682 1.79112 208.98 3.77965 212.494L32.9643 264.057C35.0047 267.662 38.8267 269.89 42.9691 269.89H100.929C105.071 269.89 108.893 267.662 110.934 264.057L140.118 212.494C142.107 208.98 142.107 204.682 140.118 201.168Z",
    stroke: "#FFEEED",
    strokeOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2729_1416",
    x: -4.21191,
    y: 8.83203,
    width: 1456.79,
    height: 774.872,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2729_1416"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2729_1416",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2729_1416",
    x1: 1073.91,
    y1: 101.116,
    x2: 1217.81,
    y2: 101.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEEED",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2729_1416",
    x1: 958.791,
    y1: 167.836,
    x2: 1102.69,
    y2: 167.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEEED",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2729_1416",
    x1: 1073.91,
    y1: 235.445,
    x2: 1217.81,
    y2: 235.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEEED",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2729_1416",
    x1: 1188.41,
    y1: 167.836,
    x2: 1332.31,
    y2: 167.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEEED",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2729_1416",
    x1: 1304.02,
    y1: 235.445,
    x2: 1447.91,
    y2: 235.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEEED",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2729_1416",
    x1: 1072.97,
    y1: 371.619,
    x2: 1216.87,
    y2: 371.619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEEED",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2729_1416",
    x1: 957.853,
    y1: 438.338,
    x2: 1101.75,
    y2: 438.338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEEED",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2729_1416",
    x1: 1072.97,
    y1: 505.948,
    x2: 1216.87,
    y2: 505.948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEEED",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2729_1416",
    x1: 1332.74,
    y1: 303.055,
    x2: 1188.85,
    y2: 303.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEEED",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2729_1416",
    x1: 1332.74,
    y1: 438.34,
    x2: 1188.85,
    y2: 438.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEEED",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2729_1416",
    x1: 1304.47,
    y1: 506.468,
    x2: 1448.36,
    y2: 506.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEEED",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2729_1416",
    x1: 1189.35,
    y1: 573.187,
    x2: 1333.25,
    y2: 573.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEEED",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2729_1416",
    x1: 986.154,
    y1: 506.468,
    x2: 842.256,
    y2: 506.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEEED",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2729_1416",
    x1: 1101.27,
    y1: 573.187,
    x2: 957.374,
    y2: 573.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEEED",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2729_1416",
    x1: 986.154,
    y1: 639.907,
    x2: 842.256,
    y2: 639.907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEEED",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2729_1416",
    x1: 871.032,
    y1: 574.078,
    x2: 727.134,
    y2: 574.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEEED",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2729_1416",
    x1: 754.977,
    y1: 639.907,
    x2: 611.079,
    y2: 639.907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEEED",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2729_1416",
    x1: 986.472,
    y1: 101.116,
    x2: 842.574,
    y2: 101.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEEED",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2729_1416",
    x1: 1100.81,
    y1: 709.144,
    x2: 956.915,
    y2: 709.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEEED",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2729_1416",
    x1: 143.898,
    y1: 73.3915,
    x2: 0,
    y2: 73.3915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEEED",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2729_1416",
    x1: 259.016,
    y1: 140.111,
    x2: 115.118,
    y2: 140.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEEED",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2729_1416",
    x1: 143.898,
    y1: 206.831,
    x2: 0,
    y2: 206.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEEED",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopHexagons);
export default __webpack_public_path__ + "static/media/desktop-hexagons.996746e8d9cff23a20eda16ad2a71ed8.svg";
export { ForwardRef as ReactComponent };